import { ApiError } from "@softmax/observatory-client/transport";

export function shouldRetryQuery(failureCount: number, error: Error): boolean {
  if (failureCount >= 2) return false;

  if (error instanceof ApiError) {
    return error.status === 408 || error.status === 429 || error.status >= 500;
  }

  return error instanceof TypeError;
}
